// utils/creditHelper.js

/**
 * ✅ SIMPLE : Vérifie si une boutique peut utiliser le système de crédits
 * @param {Object|string} boutique - Objet boutique ou ID de boutique
 * @returns {boolean} true si les crédits sont disponibles
 */
export const canShowCredits = (boutique) => {
  if (!boutique) return false;
  
  const boutiqueId = typeof boutique === 'string' ? boutique : boutique.id;
  
  // Cette boutique n'a pas accès aux crédits
  // Local avec avec Café Touba Tawfeekh
//   return boutiqueId !== '5ab295c5-882f-4ce5-b0f3-c4ce504651d8';

// Production avec avec Oud Bar Palace
     return boutiqueId !== '2f8269e6-9928-437f-a2d9-4a8fc7f88118' && boutiqueId !== '04c5b8fd-2648-4ca2-9b53-1074fd4cd57a';
};

export const canShowPromo = (boutique) => {
  if (!boutique) return false;
  
  const boutiqueId = typeof boutique === 'string' ? boutique : boutique.id;
  
  // Cette boutique n'a pas accès aux crédits
  // Local avec avec Café Touba Tawfeekh
//   return boutiqueId !== '5ab295c5-882f-4ce5-b0f3-c4ce504651d8';

// Production avec Audace ou Diodio glow skin
     return boutiqueId === '04c5b8fd-2648-4ca2-9b53-1074fd4cd57a' || boutiqueId === '73d98583-b4c8-4f4b-8924-267a28abbf1f';
};

export const canShowStock = (user) => {
  if (!user) return false;
  
  
  // Cette boutique n'a pas accès aux crédits
  // Local avec avec Café Touba Tawfeekh
//   return boutiqueId !== '5ab295c5-882f-4ce5-b0f3-c4ce504651d8';

// Production avec avec Oud Bar Palace
     return user.productAccessType !== 'SERVICE';
};

// Exemple d'utilisation dans n'importe quel composant :
/*
import { canShowCredits } from '../utils/creditHelper';
import { useBoutique } from '../contexts/BoutiqueContext';

const MonComposant = () => {
  const { currentBoutique } = useBoutique();
  const showCredits = canShowCredits(currentBoutique);

  return (
    <div>
      {showCredits && (
        <button>💳 Gérer les crédits</button>
      )}
    </div>
  );
};
*/